export default "__VITE_ASSET__CnxIOhD___"